// extracted by mini-css-extract-plugin
export default {"conditionWrapper":"NahkRQms","tipWrapper":"cgYytGu5","tipContent":"vKwax4BU","tipIcon":"xFh2Z942","card":"DJJdbL7q","conditions":"IY7Q5zYi","block":"bWHWAYos"};
    if(module.hot) {
      // 1717522983504
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  